import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, HashRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import Seo from "@/components/site/Seo";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

function stripHashFromUrl() {
  try {
    const { hash, search } = window.location;
    if (hash && hash.startsWith("#/")) {
      window.history.replaceState(null, "", `${hash.slice(1)}${search}`);
    }
  } catch (err) {
    console.warn(err);
  }
}

if (window.location.protocol !== "file:") {
  stripHashFromUrl();
}

const Router = window.location.protocol === "file:" ? HashRouter : BrowserRouter;

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: "sans-serif" }}>
          <h1>Sayfa yüklenemedi</h1>
          <pre>{String(this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <Router>
        <QueryClientProvider client={queryClient}>
          <Seo />
          <App />
        </QueryClientProvider>
      </Router>
    </RootErrorBoundary>
  </React.StrictMode>,
);
